import React, { useState } from "react";
import { MenuItem } from "@material-ui/core";

import { FlexLayout } from "js/Components/FlexLayout";
import { Popup, PopupContent } from "js/Components/Popup";
import { ImageStyles } from "common/aiConstants";

import { ImageStyleMenu } from "./ImageStyleInput";

export default function ExamplePrompts(props: {
    examplePrompts?: string[],
    onExamplePromptClick?: (prompt: string) => void,
    imageExamplePrompts?: ImageStyles[],
    onImageExamplePromptClick?: (prompt: ImageStyles) => void,
}) {
    const {
        examplePrompts = [],
        onExamplePromptClick = () => { },
        imageExamplePrompts = [],
        onImageExamplePromptClick = () => { },
    } = props;

    const [selectedImageExamplePrompt, setSelectedImageExamplePrompt] = useState<ImageStyles | null>(null);
    const [selectedExamplePrompt, setSelectedExamplePrompt] = useState<string | null>(null);

    const handleImageExamplePromptClick = (imageStyle: ImageStyles, closePopup: () => void) => {
        setSelectedImageExamplePrompt(imageStyle);
        onImageExamplePromptClick(imageStyle);
        closePopup();
    };

    const handleExamplePromptClick = (prompt: string, closePopup: () => void) => {
        setSelectedExamplePrompt(prompt);
        onExamplePromptClick(prompt);
        closePopup();
    };

    return (
        <FlexLayout align="center">
            <Popup
                label={"Example Prompts"}
                contained
                showArrow
                disableHoverState
                overrideContainerStyles={{ height: 38, border: "none" }}
                overrideLabelStyles={{ fontSize: "14px", fontWeight: "600", textTransform: "uppercase", color: "#666" }}
            >
                <PopupContent>
                    {closePopup => (
                        imageExamplePrompts.length > 0 ? (
                            <ImageStyleMenu
                                allowedImageStyles={imageExamplePrompts}
                                selectedImageStyle={selectedImageExamplePrompt}
                                onImageStyleSelected={(style: ImageStyles) => handleImageExamplePromptClick(style, closePopup)}
                            />
                        ) : ([
                            <FlexLayout justify="space-between" align="center" padding={15} border="0 0 1 px 0 solid #eee">
                                <span style={{ fontSize: "12px", fontWeight: "600", textTransform: "uppercase", color: "#666" }}>
                                    Example Prompts
                                </span>
                            </FlexLayout>,

                            ...examplePrompts.map((prompt, idx) => (
                                <MenuItem key={idx} value={prompt} selected={selectedExamplePrompt === prompt} onClick={() => handleExamplePromptClick(prompt, closePopup)}>
                                    {prompt}
                                </MenuItem>
                            ))
                        ])
                    )}
                </PopupContent>
            </Popup>
        </FlexLayout>
    );
}
